import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SystemActionIndexComponent } from './crud-index/crud-index.component';
import { SystemActionCESComponent } from './crud-ces/crud-ces.component';
import { SystemActionIndexSelectComponent } from './crud-index/crud-index-select.component';
import { SystemActionCrudIndex } from './crud-index/crud-index';
import { SystemActionsRoutingModule } from './system-actions-routing.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AngularMaterialModule } from 'src/app/angular-material.module';
import { DialogCloseModule } from 'src/app/shared/components/dialog-close/dialog-close.module';
import { DialogSaveCloseModule } from 'src/app/shared/components/dialog-save-close/dialog-save-close.module';
import { DynamicFormModule } from 'src/app/shared/components/dynamic-form/dynamic-form.module';
import { FieldsModule } from 'src/app/shared/components/fields/fields.module';
import { TableResponsiveModule } from 'src/app/shared/components/table-responsive/table-responsive.module';
import { DialogContainerModule } from 'src/app/shared/dialog-container/dialog-container.module';
import { LayoutCrudIndexModule } from '../shared/layout-crud-index/layout-crud-index.module';



@NgModule({
  declarations: [
    SystemActionCESComponent,
    SystemActionCrudIndex,
    SystemActionIndexComponent,
    SystemActionIndexSelectComponent,
  ],
  imports: [
    CommonModule,
    SystemActionsRoutingModule,
    AngularMaterialModule,
    FlexLayoutModule,
    FormsModule,
    ReactiveFormsModule,
    DynamicFormModule,
    FieldsModule,
    TableResponsiveModule,
    DialogCloseModule,
    DialogSaveCloseModule,
    DialogContainerModule,
    LayoutCrudIndexModule
  ]
})
export class SystemActionsModule { }
